import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { useStateValue } from '../providers/StateProvider';
import { catchRequest } from '../utils';
/**
 * Hook personalizado para hacer una petición GET
 * @param {string} url - Endpoint a donde se hará la petición (debe incluir body y primera diagonal), ej: /userInfo?id=1
 * @param {any[]} [dependencyArray=[]] - Al actualizarse una de estas variables; se volvera a llamar la petición.
 * @param {boolean} [visible] - Si es falso no se llama la petición, útil en componentes que inician ocultos como un Modal o Drawer.
 */

const useGetRequest = (url, dependencyArray = [], visible = true) => {
    const [{ token }, dispatch] = useStateValue();
    const [state, setState] = useState({
        data: [],
        loading: true,
        error: null,
    });
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (!visible) {
            return;
        }
        setState({ ...state, loading: true });
        const config = { headers: { Authorization: token } };
        axios.get(`${ url }`, config)
            .then((res) => {
                if (_.has(res.data, 'refreshToken')) dispatch({ type: 'ADD_TOKEN', item: { token: res.data.refreshToken } });
                if (isMounted.current) { // verifica que la pantalla que solicitó la peticion no se haya desmontado
                    if (res.data.ok) {
                        setState({ loading: false, data: res.data.result });
                    } else {
                        setState({ ...state, loading: false, error: res.data.message });
                    }
                }
            })
            .catch((err) => {
                setState({ ...state, loading: false, error: err.message });
                catchRequest(err, dispatch);
            });
    }, [...dependencyArray, visible]);

    return state;
};
export default useGetRequest;
